module.exports = __webpack_public_path__ + "assets/img/scenePic13.67f325c1.png";